



class MegaMenu {




    constructor() {
        console.log('MegaMenu')
        let hash = window.location.hash
        this.lastKey = ""
        this.initializeMenu()

    }

    initializeMenu() {
        console.log('MegaMenu.initializeMenu')
        const clickTarget = document.createElement( 'div' );
        clickTarget.classList.add('position-fixed','top-0','left-0','height-100','width-100','d-none')
        clickTarget.setAttribute('id','MegaMenu__click-target')
        document.body.append(clickTarget)
        clickTarget.addEventListener('click',(event) => {

            this.showOrHideMegaMenu(event,'background-click')
        })
        // desktop menu
        document.querySelector('.header__inline-menu .list-menu__item-shop').addEventListener('click',(event) => {
            this.megaMenuClick(event,'shop')
        })
        document.querySelector('.header__inline-menu .list-menu__item-matchmaker').addEventListener('click',(event) => {
            this.megaMenuClick(event,'matchmaker')
        })

        // mobile menu
        document.querySelector('#menu-drawer .list-menu__item-shop').addEventListener('click',(event) => {
            this.megaMenuClick(event,'shop')
        })
        document.querySelector('#menu-drawer .list-menu__item-matchmaker').addEventListener('click',(event) => {
            this.megaMenuClick(event,'matchmaker')
        })
        this.buildsubMenu()
    }

    buildsubMenu() {
        let shopSubmenu = document.getElementById('mega-menu-shop').cloneNode(true)
        shopSubmenu.setAttribute('id','shop-submenu')
        shopSubmenu.setAttribute('class','submenu')
        document.querySelector('#menu-drawer .list-menu__item-shop').parentNode.appendChild(shopSubmenu)

        let matchmakerSubmenu = document.getElementById('mega-menu-matchmaker').cloneNode(true)
        matchmakerSubmenu.setAttribute('id','matchmaker-submenu')
        matchmakerSubmenu.setAttribute('class','submenu')
        document.querySelector('#menu-drawer .list-menu__item-matchmaker').parentNode.appendChild(matchmakerSubmenu)
    }

    showOrHideMegaMenu(e,key){
        console.log('MegaMenu.showOrHideMegaMenu '+e,key)
        // show or hide desktop menu
        let megaMenu = document.querySelector('#mega-menu')
        if('background-click' === key){
            megaMenu.classList.add('d-none')
            document.body.classList.remove('mega-menu-open')
            megaMenu.setAttribute('data-currently-open','')
        }
        else if(megaMenu.classList.contains('d-none')){
            megaMenu.classList.remove('d-none')
            document.body.classList.add('mega-menu-open')
            megaMenu.setAttribute('data-currently-open',key)
        }else if(!megaMenu.classList.contains('d-none') && key === megaMenu.getAttribute('data-currently-open')){
            megaMenu.classList.add('d-none')
            document.body.classList.remove('mega-menu-open')
            megaMenu.setAttribute('data-currently-open','')
        }else if(!megaMenu.classList.contains('d-none') && key !== megaMenu.getAttribute('data-currently-open')){
            megaMenu.classList.remove('d-none')
            document.body.classList.add('mega-menu-open')
            megaMenu.setAttribute('data-currently-open',key)
        }else{
            megaMenu.classList.add('d-none')
            document.body.classList.remove('mega-menu-open')
            megaMenu.setAttribute('data-currently-open','')
        }
    }


    megaMenuClick(e,key){
        console.log('megaMenuClick.event '+key)

        e.preventDefault()
        this.showOrHideMegaMenu(e,key)

        // desktop menu
        let nodelist = document.querySelectorAll('.mega-menu__inner > div')
        for (let i = 0; i < nodelist.length; i++) {
            nodelist[i].classList.remove('mega-menu-active')
        }

        let target = document.querySelector('#mega-menu-'+key)
        if(target){
            target.classList.add('mega-menu-active')
        }

        // mobile menu
        nodelist = document.querySelectorAll('#menu-drawer .list-menu__item')
        for (let i = 0; i < nodelist.length; i++) {
            let item = nodelist[i]
            // console.log(item.classList.contains('list-menu__item-'+key),item.parentNode.classList.contains('sub-menu-active'))

            if(item.classList.contains('list-menu__item-'+key) && !item.parentNode.classList.contains('sub-menu-active')){
                nodelist[i].parentNode.classList.add('sub-menu-active')
            }
            else if(item.classList.contains('list-menu__item-'+key) && item.parentNode.classList.contains('sub-menu-active')){
                nodelist[i].parentNode.classList.remove('sub-menu-active')
            }else {
                nodelist[i].parentNode.classList.remove('sub-menu-active')
            }
        }

        return false
    }


}


let megaMenu = new MegaMenu()

class DrawerMenu {


    constructor() {
        console.log('DrawerMenu')
        let hash = window.location.hash
        this.lastKey = ""
        this.initializeMenu()
    }

    initializeMenu(){

        console.log('DrawerMenu.initializeMenu')

        // mobile menu
        document.querySelector('#menu-drawer .shop-by-collection h5').addEventListener('click',(event) => {
            this.megaMenuClick(event)
        })
        document.querySelector('#menu-drawer .shop-by-fragrance h5').addEventListener('click',(event) => {
            this.megaMenuClick(event)
        })
    }

    megaMenuClick(e){
        console.log('megaMenuClick.event '+e.currentTarget)
        e.preventDefault()
        e.currentTarget.parentNode.classList.toggle("menu-drawer-submenu-open")
    }
}


if (is2024Preview == true) {
    let drawerMenu = new DrawerMenu()
}